<template>
  <section>
    <h2 v-if="cancelExtraBenefit.length">Extra Benefits</h2>
    <div
      v-for="(val, i) in cancelExtraBenefit"
      :key="i">
      <v-checkbox
        v-model="val.content.is_enable"
        @change="updatePremium">{{val.name}}</v-checkbox>
      <div
        v-if="val.content.is_enable"
        class="extra_table">
        <div class="tr bar">
          <span class="bold">Remaining Amount</span>
        </div>
        <div
          v-for="(item, i) in val.content.keys"
          :key="i"
          :class="{'bar bold': item.type == 2}"
          class="tr">
          <span>{{item.name}}</span>
          <template v-if="item.type == 3">
            <span class="text-center">{{val.content[item.key] | formatPct }}</span>
            <span class="text-right">{{val.content[item.key2] | formatMoney(2, true)}}</span>
          </template>
          <template v-else>
            <span class="text-right">{{val.content[item.key] | formatMoney(2, true)}}</span>
          </template>
        </div>
        <div
          class="tr">
          <span class="bold way flex flex-align-center flex-sb-center">
            <span class="flex">
              <span>Way</span>
              <v-radio-group
                v-model="val.content.way"
                :list="wayList"
                :disabled="info"
                clearable
                @change="updatePremium" />
            </span>
            <span v-if="val.content.way==3">
              <v-input
                v-model="val.content.min_charge"
                key-non-chinese
                @blur="updatePremium"></v-input>
            </span>
          </span>
        </div>
        <div
          class="tr">
          <span class="bold amount_title">Remaining Amount</span>
          <span
            v-if="val.content.way == 1"
            class="day">
            <v-input
              v-model="val.content.remaining_days"
              :disabled="info"
              clearable
              @blur="updatePremium"/> / <v-input
                v-model="val.content.cycle"
                :disabled="info"
                clearable
                @blur="updatePremium" />
          </span>
          <span
            v-if="val.content.way == 2"
            class="percent">
            <v-input
              v-model="val.content.remaining_day_rate"
              :disabled="info"
              append="%"
              :keyFloatNumber="true"
              maxlength="8"
              @blur="updatePremium"
            />
          </span>
          <b class="text-right">{{val.content.remaining_premium | formatMoney(2, true)}}</b>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MixinFormat from '@/mixins/format'
export default {
  name: '',
  mixins: [MixinFormat],
  props:{
    cancelExtraBenefit:{
      type: Array,
      default: () => []
    },
    info: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      wayList:[
        {
          name: 'Days',
          id: 1
        },
        {
          name: 'Percentage',
          id: 2
        },
        {
          name: 'Min Charge',
          id: 3
        }
      ],
    }
  },
  methods: {
    updatePremium(){
      this.$emit('updatePremium')
    }
  },
}
</script>
<style lang='scss' scoped>
.extra_table{
  border: 1px solid #e1e4e8;
  border-radius: 8px;
  margin: 20px 0;
  .tr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    font-size: 14px;
    color: #24292e;
    line-height: 17px;
    border-bottom: 1px solid #e1e4e8;
    & > span {
      flex: 1;
    }
    & > span:first-child {
      color: #586069;
    }
    &:last-child {
      border-bottom: 0;
    }
    &.bar {
      background: #f6f8fa;
    }
    &:first-child{
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    &:last-child{
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
    .percent{
      flex: 0 0 auto;
      width: 100px;
    }
  }
  .bold {
    font-weight: bold;
  }
  .way{
    width: 100px;
  }
  .v-radio-group{
    margin-left: 20px;
    display: inline-block;
  }
  .day{
    text-align: center;
    .el-input{
      width: 80px;
    }
  }
  .amount_title{
    flex: 0 0 auto !important;
    width: 200px;
  }
}
/deep/ .el-checkbox{
  display: block !important;
  margin-bottom: 5px;
}
</style>
